import request from "root/js/request";

export const getAnalyticsCrossMPProductCostsIncomeDate = async ({
  cabinet_id,
  cabinet_id__in,
  marketplace,
  ...rest
}) => {
  const response = await request({
    url: "/analytics/cross-mp/product_cost_income/income_date/",
    method: "get",
    params: {
      cabinet_id,
      cabinet_id__in,
      marketplace,
      ...rest,
    },
  });
  return response.data;
};
